import { GridscaleObjects } from "./GridscaleObjects.js";
class BackupLocation extends GridscaleObjects {
  constructor(_api) {
    super(_api, "/objects/backup_locations");
  }
}
export { BackupLocation };
